import { paddings } from 'core/styles';
import styled from 'styled-components';

export const WhatIsNewDiv = styled.div`
  display: flex;
  align-items: center;
  gap: ${paddings.defaultPadding};
`;
